export default __webpack_public_path__ + "static/13-a18f2c084679829127bae550af4bda99.webp";